<template lang="pug">
    Modal
        .form
            h2 Edit Action Card's Help Text
            .form__control-group
                label Help Text
                input(
                    v-model="helpText"
                    placeholder="Help Text"
                    type="text"
                )
            .form__control-group
                label Help URL
                input(
                    v-model="helpUrl"
                    placeholder="https://"
                    type="text"
                )
            .form__control-group
                button.button__submit(
                    @click="storeHelp"
                ) Submit
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
export default {
    name: 'EditCardHelp',
    components: {
        Modal
    },
    computed: {
        getActiveLocalRecord() {
            return store.getters.getActiveLocalRecord;
        },
    },
    data() {
        return {
            helpText: '',
            helpUrl: ''
        }
    },
    methods: {
        storeHelp(){
            let activeRecord = {...this.getActiveLocalRecord};
            if(!activeRecord.help) {
                activeRecord.help = {};
            }
            activeRecord.help.text = this.helpText;
            activeRecord.help.url = this.helpUrl;

            store.commit('setActiveLocalRecord', activeRecord);

            store.commit('hideModals', true);
        }
    },
    mounted() {
        this.helpText = store.getters.getActiveLocalRecord.help.text || store.getters.getActiveLocalRecord.help.helpText;
        this.helpUrl = store.getters.getActiveLocalRecord.help.url || store.getters.getActiveLocalRecord.help.helpUrl;
    }
}
</script>
<style lang="scss" scoped>
.form {
    padding: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    h1 {
        text-align: center;
        width: 100%;
    }

    .form__control-group {
        display: flex;
        flex-direction: column;
        margin-bottom: 1rem;
        width: 100%;

        input {
            padding-left: 0.5rem;
            height: 40px;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/modals/EditCardHelp.vue